<template>
  <div class="content-box" v-if="detail">
    <x-image class="banner" el="div" :size="29" :img-src="detail.avatar_url"/>
    <div class="content-normal info">
      <h5>{{detail.package_name}}</h5>
      <p v-if="isMoreDescription" ref="desc">{{detail.package_description}}</p>
      <div v-else>{{detail.package_description}}</div>
      <i
         v-if="showMoreIcon"
         :class="['el-icon-arrow-down', { 'is-active': !isMoreDescription }]"
         @click="isMoreDescription = !isMoreDescription">
      </i>
    </div>
    <infinite-scroll
      class="scroll-box"
      :disabled="disabled"
      @to-bottom="loadMore"
      v-if="data && data.length"
    >
      <ul class="content-normal course-list">
        <li
          @touchstart="active = k"
          @click="goDetail(v)"
          v-for="(v, k) of data"
          :key="v.id"
          :class="{active: k === active}"
        >
          <div class="round-box"></div>
          <div class="block">
            <div class="order">第{{v.package_ordinal}}课</div>
            <h5>{{v.name}}</h5>
            <p class="mb-0">{{v.description}}</p>
          </div>
        </li>
      </ul>
      <div class="scroll-tips">
        <p class="no-more" v-show="noMore">没有更多数据了</p>
        <p v-show="!noMore" class="loading">
          <loading box-size="16" round-size="4"/>加载更多...
        </p>
      </div>
    </infinite-scroll>
    <no-work-placeholder v-if="data && !data.length" tip="暂无课程"/>
  </div>
</template>
<script>
import XImage from '@/components/XImage'
import Loading from '@/components/Loading'
import InfiniteScroll from '@/components/InfiniteScroll'
import NoWorkPlaceholder from './NoWorkPlaceholder'
import { get } from '@/utils/ajax'
import mixinSearch from '@/utils/mixin_search'
const defineQuery = {
  limit: 10
}
export default {
  name: 'CoursePack',
  components: {
    InfiniteScroll,
    NoWorkPlaceholder,
    Loading,
    XImage
  },
  mixins: [mixinSearch(defineQuery)],
  created() {
    this.refresh()
  },
  data() {
    return {
      detail: null,
      query: Object.assign({}, defineQuery),
      asyncQuery: Object.assign({}, defineQuery),
      data: null,
      page: 1,
      active: 0,
      disabled: true,
      noMore: false,
      isMoreDescription: true,
      showMoreIcon: false
    }
  },
  computed: {
    id() {
      return this.$route.query.id
    },
    isCustom() {
      return this.$route.query.isCustom === 'true'
    }
  },
  methods: {
    refresh() {
      this.getDetail()
      this.getCourse()
    },
    async getDetail() {
      this.detail = await get(
        `/edu/wap/${this.isCustom ? 'upload' : 'lesson'}/packages/${this.id}`
      )
      this.$nextTick(() => {
        if (this.$refs.desc.scrollHeight > this.$refs.desc.offsetHeight) this.showMoreIcon = true
      })
    },
    goDetail(v) {
      sessionStorage.setItem('courseDetail', JSON.stringify(v))
      this.$router.push({ name: 'courseDetail', query: { id: v.id, isCustom: this.isCustom + '' } })
    },
    async getCourse(type = 'fresh', ext = { page: 1 }) {
      this.disabled = true
      const { items } = await get(
        `/edu/wap/${this.isCustom ? 'upload' : 'lesson'}/packages/${
          this.id
        }/lessons`,
        Object.assign({}, defineQuery, this.$route.query, ext),
        { loading: ext.page === 1 }
      )
      const length = items.length
      if (length && type === 'more') this.data = this.data.concat(items)
      if (type === 'fresh') {
        this.data = items
        this.page = 1
      }
      if (length === 0 || length < this.query.limit) {
        this.noMore = true
      } else {
        this.disabled = false
        this.page++
      }
    },
    loadMore() {
      if (this.disabled) return
      this.getCourse('more', { page: this.page })
    }
  }
}
</script>

<style lang="stylus" scoped>
>>> .no-work-placeholder svg
  margin-top 50px
.content-box
  height 100%
  display flex
  flex-direction column
.scroll-box
  flex-grow 1
.banner
  height 211px
  flex-shrink 0
.info
  padding-top 11px
  border-bottom 10px solid #f4f4f4
  position relative
  h5
    text-ellipsis(1)
  p
    margin-bottom 28px
    text-ellipsis(3)
  div
    margin-bottom 28px
  i
    position absolute
    bottom 9px
    right 9.2%
  .is-active
    transform rotate(180deg)
    transition transform .3s
.scroll-tips
  min-height 20px
.scroll
  flex-scroll()
  position relative
.no-more
  text-align center
.loading
  display flex
  justify-content center
  margin-right 5px
  >>> .spinner
    margin-right 10px
.course-list
  margin-top 20px
  position relative
  li
    display flex
    position relative
    &:before
      content ''
      display block
      width 2px
      background-color #bbb
      height 100%
      position absolute
      left 4px
      top 13px
    &:last-child
      &:before
        display none
  .round-box
    width 20px
    display flex
    justify-content flex-start
    flex-shrink 0
    position relative
    &:after
      z-index 1
      background-color white
      content ''
      position absolute
      round(7px)
      top 13px
      border 2px solid #bbb
  .block
    width 296px
    flex-shrink 0
    padding 10px
    border-radius 4px
    box-shadow 0 0 10px 0 rgba(101, 113, 117, 0.1)
    margin-bottom 20px
  .order
    margin-bottom 10px
    line-height 14px
  p
    text-ellipsis(1)
    font-size 12px
  .active
    .round-box
      &:after
        round(7px)
        border-color $themeColor
        background-color $themeColor
    .block
      background-image linear-gradient(-135deg, #68EAD0 0%, #459EEF 100%)
      box-shadow 0 4px 10px 0 rgba(84, 190, 226, 0.5)
      color white
    h5
      color white
</style>
